<script setup lang="ts">
import { ref } from 'vue';
import { promoCampaignSubscriptionsApi } from '@/api/promo-campaign-subscriptions';
import PromotionalCodeCard from './promotional-code-card.vue';
import PromoCampaignCard from './promo-campaign-card.vue';

interface Props {
  recommender: Recommender
  availableCampaigns: PromoCampaign[]
}

const props = defineProps<Props>();

const loading = ref(false);
const error = ref(false);

async function createPromoCampaignSubscription(promoCampaignId:number) {
  try {
    loading.value = true;
    await promoCampaignSubscriptionsApi.create(props.recommender.id, promoCampaignId);
    window.location.reload();
  } catch (e) {
    error.value = true;
  } finally {
    loading.value = false;
  }
}
</script>
<template>
  <div class="m-4 flex max-w-2xl flex-col rounded-lg bg-white p-4 shadow-md md:mx-auto">
    <div class="flex w-full flex-col items-center md:flex-row">
      <p class="shrink-0 text-xl font-medium text-z-gray-900">
        Bienvenido, {{ recommender.firstName }}
      </p>
      <a
        href="/recomendadores/cerrar_sesion"
        class="ml-2 flex shrink-0 text-sm text-z-gray-800 underline"
      >
        <img
          src="@/assets/icons/logout.svg"
          class="h-5 w-5"
        >
        <p>Cerrar Sesión</p>
      </a>
    </div>
    <div class="mt-6 flex flex-col space-y-3">
      <p class="text-z-gray-800">
        Estos son tus códigos activos:
      </p>
      <promotional-code-card
        v-for="promotionalCode in recommender.promotionalCodes"
        :key="promotionalCode.id"
        :promotional-code="promotionalCode"
      />
    </div>
    <div
      v-if="availableCampaigns.length > 0"
      class="mt-8 flex flex-col space-y-3 border-t pt-4"
    >
      <p class="text-z-gray-800">
        Las siguientes campañas están disponibles:
      </p>
      <div class="flex flex-col md:grid md:grid-cols-3 md:space-x-4">
        <promo-campaign-card
          v-for="promoCampaign in availableCampaigns"
          :key="promoCampaign.id"
          :promo-campaign="promoCampaign"
          :loading="loading"
          @subscribe="createPromoCampaignSubscription(promoCampaign.id)"
        />
      </div>
    </div>
  </div>
</template>
